import React from 'react';
import { Page } from '../Page';
import { PullQuote } from '../PullQuote';
export function PagePlateaus() {
  return <Page pageNumber={38} variant="light" data-id="element-1560" data-mp="1u5q940yfy01h">
      <div className="flex h-full gap-12" data-id="element-1561" data-mp="1u4f3rwpckk89">
        {/* Left 1/3 Column */}
        <div className="w-1/3 flex flex-col pt-32" data-id="element-1562" data-mp="1yy01roqxxe7g">
          <PullQuote text="A plateau is not a failure. It is a signal to review your habits." variant="light" data-id="element-1563" data-mp="22zldv7vnhogl" />

          <div className="mt-auto border-t border-[#D8D8D0] pt-6" data-id="element-1564" data-mp="16anhjl895ihb">
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-2" data-id="element-1565" data-mp="1b748en6u6ay3">Remember</h3>
            <p className="text-[11px] text-[#7A7A70] leading-[1.6]" data-id="element-1566" data-mp="1f9r44z6mog0k">
              Refer back to the "Managing Your Dose" page. A plateau is one of
              the few times increasing your dose might be the right next step,
              but only if your habits are dialed in.
            </p>
          </div>
        </div>

        {/* Right 2/3 Column */}
        <div className="w-2/3 flex flex-col" data-id="element-1567" data-mp="2vlwf8kr2zteg">
          <div className="mb-8 pt-4" data-id="element-1568" data-mp="3a2nfdp1e23lt">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1569" data-mp="3a1lu6rqns0qd">
              Challenges
            </p>
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1570" data-mp="303xudne7431c">
              Navigating <span className="text-tealslate" data-id="element-1571" data-mp="2v4v2l4n87tbb">Plateaus</span>
            </h1>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-1572" data-mp="2v6xpvgwzv8cc" />
          </div>

          <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-8" data-id="element-1573" data-mp="2r41f2cdp4giy">
            A plateau is not a failure. It is a normal, expected part of the
            weight loss process. Your body is designed to fight weight loss to
            protect you from starvation. When you lose weight, your metabolism
            slows down to match your new, smaller body size.
          </p>

          <div className="border-l-4 border-tealslate pl-5 py-4 bg-[#EAEAE4] border-y border-r border-[#D8D8D0] mb-8" data-id="element-1574" data-mp="27fiih9qd20u8">
            <p className="text-sm font-serif text-[#1F1F1F] leading-[1.6]" data-id="element-1575" data-mp="23eynabpcl7aq">
              A true plateau is 4 weeks with no change in weight AND no change
              in measurements.
            </p>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6 mb-8" data-id="element-1576" data-mp="1xsy3d90512jc">
            <h3 className="font-serif text-lg text-[#1F1F1F] mb-4" data-id="element-1577" data-mp="1jsx0jo0bbl18">
              Before assuming a true plateau, check:
            </h3>
            <ul className="space-y-3 text-xs text-[#7A7A70]" data-id="element-1578" data-mp="1ot2pgwf76tfm">
              <li className="flex items-center gap-3" data-id="element-1579" data-mp="2chu92zeq23gs">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1580" data-mp="2gi4nn0gky279" />
                Are you sleeping enough?
              </li>
              <li className="flex items-center gap-3" data-id="element-1581" data-mp="22pyaln8q4bc1">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1582" data-mp="27pue7ldie0r2" />
                Are you hydrated?
              </li>
              <li className="flex items-center gap-3" data-id="element-1583" data-mp="2vedmw20h0fjo">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1584" data-mp="2vdkfqzxlno10" />
                Are you hitting your protein targets?
              </li>
              <li className="flex items-center gap-3" data-id="element-1585" data-mp="39jmatlb35vi6">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1586" data-mp="35jlm97u9w3xe" />
                Are you lifting weights consistently?
              </li>
              <li className="flex items-center gap-3" data-id="element-1587" data-mp="3ja8o38vby9xp">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1588" data-mp="3eb5gbgnytpm1" />
                Are you under high stress?
              </li>
            </ul>
          </div>

          <div className="space-y-4 text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1589" data-mp="2qnw63qbrql0l">
            <p data-id="element-1590" data-mp="2mmandocjzcih">
              <strong className="text-[#1F1F1F]" data-id="element-1591" data-mp="2mmu8tf1ewj19">Common causes:</strong>{' '}
              Metabolic adaptation, water retention, muscle gain offsetting fat
              loss, or inconsistent tracking.
            </p>
            <p data-id="element-1592" data-mp="ftrq52ku7jdf">
              <strong className="text-[#1F1F1F]" data-id="element-1593" data-mp="ft8kak8golfr">What to do:</strong> Review the
              fundamentals first. Consider tracking calories temporarily to
              ensure you are still in a deficit. Talk to your provider about a
              dose adjustment only after addressing your habits.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}